import api from "@/services/api";

export default {
  fetchUnfilledDates(payload) {
    return api
      .post(`missingdatescalc/`, payload)
      .then((response) => response.data);
  },
};
